import * as HttpService from './HttpService'

let namespace = 'companies'

const findAll = (options, cb, errorCb) => {
    HttpService.get(namespace, options, cb, errorCb)
}

const budgetCalc = (options, cb, errorCb) => {
    HttpService.get('company/budget', options, cb, errorCb)
}

const updateBudgetCalc = (body, cb, errorCb) => {
    HttpService.post('company/budget', body, cb, errorCb)
}

const employeeCalc = (options, cb, errorCb) => {
    HttpService.get('company/employee-calc', options, cb, errorCb)
}

const updateEmployeeCalc = (body, cb, errorCb) => {
    HttpService.post('company/employee-calc', body, cb, errorCb)
}

const change = (body, cb, errorCb) => {
    HttpService.post('change-company', body, cb, errorCb)
}

export {
    findAll,
    change,
    budgetCalc,
    updateBudgetCalc,
    employeeCalc,
    updateEmployeeCalc
}



// WEBPACK FOOTER //
// ./src/services/companyService.js